// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","InstagramEmbed":"bas_a","InstagramEmbed__mask":"bas_b bhl_bi bhl_bo bhl_wx"};